<div class="alertDialog">
  <div class="text-center btn-block mb-2">
    <img src="~/../../assets/images/mail.svg" width="70" class="img-fluid" />
  </div>
  <div mat-dialog-content>
    <p class="body-text" *ngIf="!isChatRedirect && !isDashboardRedirect">
      To access this page please verify your account with the email sent to your email id.
    </p>

    <p class="body-text" *ngIf="isDashboardRedirect">
      A verification email was sent earlier when the account was created. Please check your inbox or spam folder and
      verify the email.
    </p>
    <p class="body-text" *ngIf="isChatRedirect">
      Email verification required. Please verify your email using the activation link sent to your inbox before
      verifying your phone number.
    </p>
    <p class="resend-email">
      Can't able to find the email? <a cdkFocusInitial (click)="resendVerificationMail()">Resend Email</a>
    </p>
  </div>
  <div mat-dialog-actions class="dialog-actions-right">
    <!-- <button
      mat-button
      color="primary"
      class="resend-email btn-lg"
      mat-dialog-close
      cdkFocusInitial
      (click)="resendVerificationMail()"
    >
      Resend Email
    </button> -->

    <button
      mat-flat-button
      mat-dialog-close
      color="primary"
      class="btn-block btn-lg"
      cdkFocusInitial
      (click)="navigateToPage()"
    >
      OK
    </button>
  </div>
  <!-- <div mat-dialog-actions>
    <div class="text-center btn-block">
      <button
        mat-button
        mat-dialog-close
        color="primary"
        class="btn-lg"
        cdkFocusInitial
        (click)="resendVerificationMail()"
      >
        Resend Email
      </button>
    </div>
    <div class="text-center btn-block">
      <button
        mat-flat-button
        mat-dialog-close
        color="primary"
        class="btn-lg"
        cdkFocusInitial
        (click)="navigateToPage()"
      >
        OK
      </button>
    </div>
  </div> -->
</div>
